import { RC_SLIDER_HANDLE_SELECTOR, RC_SLIDER_RAIL_SELECTOR } from '../constants';

export function isRailClickTarget(target) {
  const isRail = target.closest(RC_SLIDER_RAIL_SELECTOR) != null;
  const isHandle = target.closest(RC_SLIDER_HANDLE_SELECTOR) != null;

  return isRail && !isHandle;
}
